import { Component, ChangeDetectionStrategy, Input, ViewChild, signal } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';
import { PricingError } from '@pedix-workspace/utils';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';

@Component({
  selector: 'pxw-pricing-errors-dialog',
  templateUrl: './pricing-errors-dialog.component.html',
  styleUrls: ['./pricing-errors-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent, CurrencyFormatPipe],
})
export class PricingErrorsDialogComponent {
  @ViewChild(ModalDialogComponent) modalDialog: ModalDialogComponent;

  readonly pricingErrors = signal<PricingError[]>([]);
  readonly dialogType = signal<'confirm' | 'alert'>('confirm');

  open(pricingErrors: PricingError[], dialogType: 'confirm' | 'alert') {
    this.pricingErrors.set(pricingErrors);
    this.dialogType.set(dialogType);

    return this.modalDialog.open();
  }
}
